import type { FaireProductEntity } from "../../entity_types/product";

export const p_fb5q5vj6gz: FaireProductEntity = {
  token: "p_fb5q5vj6gz",
  type: "product",
  name: "Milky Santal– HI-FI Incense Sticks",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/835e4a8ec46a2c7853692868c43abaf50f15d7609092592bcfc42145cac0546a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/049f24ccb447720d40ebd88f2f8a83f9c0bbd0ca328a6c7e6fc1fd50e812b5cc.jpeg",
    "https://cdn.faire.com/fastly/1bf2d3826b3d2c1352108216fa7b9940ae25b652cf4145e1b78ce76724d60c33.jpeg",
    "https://cdn.faire.com/fastly/ad8c217d42a768bf7e02cfec6617f1fe752680b57f5205420ef526380e9d9438.jpeg",
    "https://cdn.faire.com/fastly/401fbceeee82e55c3b57c6d6be6d84875380cc677345e93112d89a0bd690bcc8.jpeg",
  ],
  priceDollars: 9.5,
  description:
    "*RESTOCKING IN SUMMER 2026*\n\n\nA creamy, grounding gourmand. Rice milk vapor, warm plush robes, grounding sandalwood.\n\nMilky Santal is an elevated, lactonic take on a gourmand. Comforting, soft, and quietly luxurious, like a warmed plush robe and rice milk-infused baths. Skin-like musks and nuanced woods bring a velvet complexity, instantly upping the coziness.\n\nTop notes of rice milk vapor, oats, and patchouli leaf are blended with santal, warm cashmere, and white jasmine, then slightly sweetened by creamy tonka bean, musk, ambrette seed, and woody amyris, creating a nuanced gourmand.\n\nPRODUCT INFORMATION:\n\nIncense quickly transforms a room: transformative smoke uplifts the space while our signature scents linger for hours even after extinguishing.\n\nEach vermilion-hued charcoal-based Incense stick is hand-dipped in California using fine fragrance oils.\n\nEach stick burns for 1 hour; depending on room size, scent longevity lasts between 2-4 hours.",
  tags: [],
  msrpDollars: 20,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-07-01T21:36:02.903Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
